import KBVisibility from "./KBVisibility";

export default class CreateKBContentRequest {
  public id = '';
  public title = '';
  public slug = '';
  public tags: string[] = [];
  public parentId = '';
  public order = 0;
  public visibility: number = KBVisibility.Internal;
  public relatedContentIds: string[] = [];
  public searchKeywords: string[] = [];
}
